import React, { useReducer } from 'react';

export const MyIdContext = React.createContext();

const initialStatus = {
  my_id_panel: null,
  my_id: null,
};

const MyIdReducer = (state, action) => {
  switch (action.type) {
    case 'set-my-id':
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

export const MyIDProvider = (props) => {
  const [state, dispatch] = useReducer(MyIdReducer, initialStatus);

  return (
    <MyIdContext.Provider value={[state, dispatch]}>
      {props.children}
    </MyIdContext.Provider>
  );
};
